<template>
  <v-layout column>
    <MatterClientInfo
      :client="client"
      :assignedStaff="assignedStaff"
      :customAvatarSize="$vuetify.breakpoint.mdAndUp ? '32px' : '48px'"
    >
      <template v-slot:actions-activator>
        <v-layout v-if="shouldDisplayShowMoreButton && !loading" class="button-container" :align-center="!$vuetify.breakpoint.mdAndUp" :align-end="$vuetify.breakpoint.mdAndUp">
          <v-btn @click="toggleShowMore"  height="20px" class="show-more-button" elevation="0" text>
            {{shouldDisplayExtraDetails ? $t('common.words.show_less') : $t('common.words.show_more')}}
          </v-btn>
        </v-layout>
      </template>

    </MatterClientInfo>
    <component
      :fullscreen="true"
      v-model="shouldDisplayExtraDetails"
      :is="!$vuetify.breakpoint.mdAndUp ? 'VcitaDialog' : 'div'">
      <v-layout align-center class="mobile-header" v-if="!$vuetify.breakpoint.mdAndUp" >
        <v-btn
          height="24px"
          width="24px"
          class="close-button"
          @click="shouldDisplayExtraDetails = false"
          icon
        >
          <v-icon size="20">icon-back-16</v-icon>
        </v-btn>
        <v-layout justify-start align-center class="matter-term-title">
          {{ $t('booking.new_booking_dialog.matter_and_client_info', {matter_term: $t(matterTerm)}) }}
        </v-layout>
      </v-layout>
      <v-layout
        column
        :class="{hide: !shouldDisplayExtraDetails}"
        class="matter-extra-details">
        <v-layout v-if="!$vuetify.breakpoint.mdAndUp" class="pb-4">
          <AvatarImage
            :image-path="client.photo_path"
            :name="client.full_name"
            :color-id="client.color_id"
            :custom-size="'48px'"
            class="contact-avatar-wrapper"
          />
          <v-layout justify-center column class="client-details">
            <div class="matter-name">
              {{shouldDisplayMatterName ? client.matter_name : client.full_name}}
            </div>
            <v-layout v-if="shouldDisplayMatterName" class="client-name-container" align-center>
              <v-icon size="20px">
                icon-client-card
              </v-icon>
              <span class="client-name">
              {{client.full_name}}
            </span>
            </v-layout>
          </v-layout>
        </v-layout>


        <v-layout v-if="shouldDisplayMatterContactInfo" class="matter-contact-info" column>
          <v-layout column class="matter-fields">
            <v-layout align-center v-if="client.phone_to_display">
            <span class="field-name">
              {{$t('client.matters.matter_page.contact.phone')}}
            </span>
              <v-layout align-center class="field-value">
              <span class="my-auto">
                 {{client.phone_to_display}}
              </span>

                <v-tooltip bottom
                           content-class="warning-tooltip"
                           v-if="invalidMobileNumber">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="warning-icon"
                            v-bind="attrs"
                            v-on="on">
                      icon-warning
                    </v-icon>
                  </template>
                  <div class="warning-tooltip-wrapper">
                    <div class="warning-tooltip-header">
                      {{$t('client.matters.matter_page.contact.invalid_phone_title')}}
                    </div>
                    <div class="warning-tooltip-message">
                      {{$t('client.matters.matter_page.contact.invalid_phone_message')}}
                    </div>
                  </div>
                </v-tooltip>
              </v-layout>
            </v-layout>
            <v-layout v-if="client.email">
            <span class="field-name">
              {{$t('client.matters.matter_page.contact.email')}}
            </span>
              <v-layout class="field-value">

                {{client.email}}

                <v-tooltip bottom
                           content-class="warning-tooltip"
                           v-if="currContact && currContact.blocked">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="warning-icon"
                            v-bind="attrs"
                            v-on="on">
                      icon-warning
                    </v-icon>
                  </template>
                  <div class="warning-tooltip-wrapper">
                    <div class="warning-tooltip-header">
                      {{$t('client.matters.matter_page.contact.blocked_email_title')}}
                    </div>
                    <div class="warning-tooltip-message">
                      {{$t('client.matters.matter_page.contact.blocked_email_message')}}
                    </div>
                  </div>
                </v-tooltip>

              </v-layout>
            </v-layout>
            <v-layout v-if="assignedStaff">

            <span class="field-name">
              {{$t('client.matters.matter_page.primary_staff')}}
            </span>

              <v-layout align-center class="field-value">
                <AvatarImage class="staff-avatar" customSize="24px" :name="assignedStaff.display_name" :imagePath="assignedStaff.photo_path" :colorId="assignedStaff.color_id"> </AvatarImage>
                <span class="assigned-staff-name">
                {{assignedStaff.display_name}}
              </span>
              </v-layout>

            </v-layout>
          </v-layout>
        </v-layout>

        <v-layout v-if="shouldDisplayMatterActivity" column class="matter-activity-data">

          <v-layout justify-space-between v-if="bookings && bookings.last" class="matter-activity">
            <v-layout class="activity-label">
              <VSvgIcon class="activity-icon"
                        viewbox="0 0 26 26"
                        size="16 16"
                        tag="28" icon="last-appointment"
              />
              <v-layout align-center class="activity-name">
                {{$t('client.matters.matter_page.summary.last_booking')}}
              </v-layout>
            </v-layout>
            <v-layout align-end column class="activity-value">
              <v-layout class="last-booking-date" justify-end>
                {{lastMeetingDate}}
              </v-layout>
              <v-tooltip
                :top="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-on="on"
                    v-bind="attrs"
                    class="last-booking-title">
                    {{bookings.last.title}}
                  </div>
                </template>
                {{bookings.last.title}}
              </v-tooltip>
            </v-layout>
          </v-layout>

          <v-layout  justify-space-between class="matter-activity" v-if="bookings && parseInt(bookings.noShows)">
            <v-layout class="activity-label">
              <VSvgIcon class="activity-icon"
                        viewbox="0 0 26 26"
                        size="16 16"
                        tag="26" icon="noshow"
              />
              <v-layout align-center class="activity-name">
                {{$t('client.matters.matter_page.summary.number_of_no_shows')}}
              </v-layout>
            </v-layout>
            <div class="activity-value">
              {{bookings.noShows}}
            </div>
          </v-layout>

          <v-layout  justify-space-between v-if="payments && payments.open && parseFloat(payments.open.value)" class="matter-activity">
            <v-layout class="activity-label">
              <VSvgIcon class="activity-icon"
                        viewbox="0 0 26 26"
                        size="16 16"
                        tag="26" icon="pending-payments"
              />
              <v-layout column justify-center class="activity-name">
                {{$t('client.matters.matter_page.summary.pending_payments')}}
              </v-layout>
            </v-layout>
            <v-layout justify-end class="activity-value">
              {{payments.open.value_h}}
            </v-layout>
          </v-layout>

          <v-layout  justify-space-between v-if="serviceCreditsLeft" class="matter-activity">
            <v-layout class="activity-label">
              <VSvgIcon class="activity-icon"
                        viewBox="0 0 26 26"
                        size="16 16"
                        tag="26" icon="package"
              />
              <v-layout column justify-center class="activity-name">
                {{ $t('client.matters.matter_page.summary.package_credits') }}
              </v-layout>
            </v-layout>
            <v-layout align-end justify-end class="activity-value">
              <span class="credits-left">
                {{serviceCreditsLeft}}
              </span>
              <span class="credits-text">
                {{$t('client.matters.matter_page.summary.credits')}}
              </span>

            </v-layout>
          </v-layout>

        </v-layout>
      </v-layout>
    </component>
  </v-layout>


</template>

<script>
  import MatterClientInfo from "@/modules/matters/components/MatterClientInfo/MatterClientInfo.vue"
  import {AvatarImage, VSvgIcon, VcitaDialog} from "@/modules/common/components";

  import moment from "moment";

  export default {
    components: {
      MatterClientInfo,
      AvatarImage,
      VSvgIcon,
      VcitaDialog,

    },
    props: {
      client: {
        type: Object,
        required: true,
      },
      assignedStaff: {
        type: Object,
        default: () => null,
      },
      serviceCreditsLeft: {
        type: Number,
        default: 0,
      }
    },
    created() {
      this.loadMatterData()
    },
    data() {
      return {
        shouldDisplayExtraDetails: false,
        loading: false,
      }
    },
    methods: {
      toggleShowMore() {
        const newVal = !this.shouldDisplayExtraDetails
        this.$track('matter client info - show more toggle', { value: newVal } )
        this.shouldDisplayExtraDetails = newVal

      },
      async loadMatterData() {
        if(!this.$store) {
          return
        }
        this.loading = true
        try {
          await this.$store.dispatch({type: 'mattersModule/fetchMatter', payload: {matterUid: this.client.matter_uid, reload: true}});
          await Promise.all([
            this.$store.dispatch({type: 'mattersModule/loadPaymentsSummary'}),
            this.$store.dispatch({type: 'mattersModule/loadMatterSummary'}),
            this.$store.dispatch({type: 'mattersModule/fetchContact'}),
          ])
        } catch (e) {

        }

        this.loading = false
      },
    },
    computed: {
      matterTerm() {
        return (this.$store.getters && this.$store.getters['accountModule/businessTerm'].capitalized_singular) || 'settings.business_page.business_terminology.terms.clients.capitalized_singular';
      },
      shouldDisplayShowMoreButton() {
        return this.shouldDisplayMatterActivity || this.shouldDisplayMatterContactInfo
      },
      shouldDisplayMatterContactInfo() {
        return (this.client && (this.client.phone_to_display || this.client.email)) || this.assignedStaff
      },
      shouldDisplayMatterActivity() {
        const bookings = this.bookings
        const payments = this.payments
        const serviceCreditsLeft = this.serviceCreditsLeft
        return (bookings && bookings.last) || (bookings && parseInt(bookings.noShows)) || (payments && payments.open && parseFloat(payments.open)) || serviceCreditsLeft
      },
      invalidMobileNumber() {
        const contact = this.currContact
        return contact && contact.notifications_phone && contact.notifications_phone.value && !contact.is_notifications_phone_mobile;
      },
      shouldDisplayMatterName() {
        return this.client.matter_name !== this.client.full_name
      },
      payments() {
        return this.$store && this.$store.getters['mattersModule/paymentsSummary']
      },
      bookings() {
        let res = this.$store && this.$store.getters['mattersModule/bookingSummary']
        return res
      },
      currContact() {
        return this.$store && this.$store.getters['mattersModule/currContact']
      },
      lastMeetingDate() {
        if(this.bookings && this.bookings.last) {
          const momentObj = moment(this.bookings.last.start_time)
          return this.$vuetify.lang.current === 'he' ? `${momentObj.format('MM')} ${momentObj.format('MMM')}` : `${momentObj.format('MMM')} ${momentObj.format('MM')}`
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .contact-avatar-wrapper {
    @include i-margin-mirror(0, 16px);
    @include md-and-up {
      @include i-margin-mirror(0, 13px);
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -0.93px;
    }
  }
  .staff-avatar {
    @include i-margin-mirror(0, 12px);
    ::v-deep {
      .avatar-initials {
        font-size: 9px;
      }
    }
  }
  .matter-extra-details {
    max-height: 1000px;
    transition: max-height,padding,border-width 0.9s,0.6s,0.3s;

    overflow: hidden;
    background: #fff;

    height: 100%;
    min-width: 85vw;
    padding: 20px 24px;
    border-radius: 6px;

    @include md-and-up {
      padding: 24px 0;
      min-width: revert;
      border-radius: revert;
      height: revert;
      & > div:first-child {
        border-top: 1px solid rgba(0, 0, 0, 0.12);
      }
    }



    & > div {
      flex: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }
    &.hide {
      max-height: 0;
      padding: 0;
      border-width: 0;
      margin: 0;
    }
    .matter-contact-info {
      padding: 12px 0;
    }
  }

  .matter-term-title {
    font-family: var(--primary-font-family);
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0px;
  }
  .matter-activity-data {
    padding: 20px 0;
    font-family: var(--primary-font-family);
    .activity-icon {
      margin-top: auto;
      margin-bottom: auto;
      margin-inline-end: 8px;
      filter: brightness(0) saturate(100%) invert(0%) sepia(3%) saturate(33%) hue-rotate(330deg) brightness(104%) contrast(100%);
    }
    .matter-activity {
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
    .activity-name {
      font-size: 13px;
      line-height: 16px;
      letter-spacing: -0.3px;
      color: rgba(0, 0, 0, 0.54);
    }
    .activity-value {
      white-space: nowrap;
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: 0px;
      margin-inline-start: 8px;
    }
    .last-booking-title {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 170px;
    }
    .last-booking-date {
      color: rgba(0, 0, 0, 0.54);
    }
  }
  .warning-tooltip {
    background-color: white;
    padding: 0;
    width: 250px;
    height: 100px;
    box-shadow: 0 2px 5px 1px rgba(18, 52, 77, 0.2), 0 12px 6px 7px rgba(18, 53, 77, 0.04);
    opacity: 1 !important;
    pointer-events: auto;
    z-index: 10000 !important;
  }
  .warning-tooltip-wrapper {
    font-family: var(--primary-font-family);

    .warning-tooltip-header {
      color: $red-color-1;
      background-color: $red-color-2;
      font-size: 12px;
      font-weight: 600;
      padding: 10px;
    }

    .warning-tooltip-message {
      font-size: 11px;
      color: $blue-color-2;
      font-weight: 500;
      line-height: normal;
      padding: 10px 12px;
    }
  }
  .warning-icon {
    font-size: 13px;
    color: #f26950;
    padding: 0 5px;
  }
  .matter-fields {
    & > div:not(:last-child) {
      margin-bottom: 8px;
    }
  }
  .field-name {
    font-family: var(--primary-font-family);
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: rgba(0, 0, 0, 0.54);
  }
  .field-value {
    font-family: var(--primary-font-family);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    margin-inline-start: 8px;
  }

  .matter-name {
    font-family: var(--primary-font-family);
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-stretch: normal;
    line-height: 1.33;
    margin-bottom: 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    @include md-and-up {
      line-height: 1.29;
      letter-spacing: 0.1px;
      color: rgba(0, 0, 0, 0.87);
      margin-bottom: 0;
      font-size: 15px;
      font-weight: 500;
    }
  }
  .client-name-container {
    font-family: var(--primary-font-family);
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.54);
  }
  .client-name {
    margin: 0 9px;
  }
  .button-container {
    align-self: stretch;
    flex: 0 0 auto;
    .show-more-button {
      padding: 0;
      font-family: var(--primary-font-family);
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: -0.26px;
      text-align: right;
      color: $blue-color-4;
      text-transform: initial;
      @include md-and-up {
        font-size: 13px;
        line-height: normal;
        letter-spacing: normal;
      }
    }
  }
  .mobile-header {
    font-family: var(--primary-font-family);
    background: #fff;
    padding: 16px 20px;
    border-top: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);;
  }

  .close-button {
    color: rgba(0, 0, 0, 0.4);
  }
  .credits-left {
    font-family: var(--primary-font-family);
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0px;
  }
  .credits-text {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.3px;
    margin-inline-start: 2px;
  }
</style>
